/*
 * @Author: Teemo Ding
 * @Date: 2021-09-06 09:59:35
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-16 15:10:40
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/Voucher/List/index.tsx
 */

import React, { memo, useState } from 'react';
import { getCurrentSalesChannel } from 'src/constrains/SalesChannelHOC/slice';
import ListPageLayout from 'src/layout/ListPageLayout/ListPageLayout';
// import {
//   publishSubscription,
//   toDraftSubscription,
//   duplicateSubscription,
//   archiveSubscription,
// } from '@/src/request/salesChannel/discounts/subscriptionBuy';
import { getVouchersListPage } from 'src/request/salesChannel/discounts/voucher';
//import { NEW } from '@/src/tools/constant';
import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';
import GlobalTable from '@/src/constrains/BulkEditorTable/BulkEditorTable2';
import { EnumStatus } from 'src/types/common/discount';
// import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
// import { Modal } from 'src/components/Antd';
import css from './css.module.less';
// import {
//   //activeChange, //setTableSetting
//   //setAllDataTotal,
// } from './slice';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { useAfterDidMountEffect } from 'src/tools/customHooks';

import NoPermission from '@/src/components/NoPermission';
import { useQueries, useSelectRows } from '@/src/tools/hooks/listPageHooks';
import { defaultPageSize } from 'src/tools/constant';
import { discountPermissions } from '../../Components/hooks/permissions';
import { handleOnGetStoreTimezoneUTC } from '@/src/tools/tools';

import {
  // addButtonMenu,
  breadcrumbData,
  columns,
  tabsConfig,
} from './config';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { SalesChannelModeAccessControlHOC } from 'src/constrains/SalesChannelModeAccessControl';
interface IParams {
  uuid: string;
}

const SubscriptionBuyList = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  // const state = useSelector(
  //   (state: any) => state.salesChannelDiscountsSubscriptionBuy,
  // );
  const salesChannel = useSelector(getCurrentSalesChannel());
  const { name: salesChannelName } = salesChannel || {};
  const params = useParams<IParams>();
  const history = useHistory();
  // const {
  //   // sort,
  //   // searchList: searchListArray,
  //   // filter,
  //   //tabsActive,
  //   allDataTotal,
  //   // tableSettings,
  // } = state;

  const [tabsActive, setTabActive] = React.useState('');
  const { uuid: salesChannelUuid } = params;
  const { canViewList, canViewDetail } = discountPermissions(salesChannelUuid);
  const constants = {
    salesChannelUuids: [salesChannelUuid],
  };

  // const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [flashSales, setFlashSales] = useState([]);
  /* 分页 */
  const [current, setCurrent] = useState(0);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [sortBy, setSortBy] = useState<any>();
  // const [timezoneInGmt, setTimezoneInGmt] = useState('');
  const storeTimezoneUTC = handleOnGetStoreTimezoneUTC();

  const { clearSearchState, queryProps, search } = useQueries([], []);

  /* 弹窗 */
  // const [showModal, setShowModal] = useState<boolean>(false);
  // const [modalTitle, setModalTitle] = useState<string | ReactNode>('');
  // const [modalContent, setModalContent] = useState<ReactNode>('');

  /* 多选 */
  const {
    rowSelection,
    selectedRowKeys,
    selectedAll,
    setSelectedAll,
    setMappedSelectedKeys,
    //mappedSelectedKeys,
    setSelectedRowKeys,
  } = useSelectRows(flashSales);

  // const statusChangeModal = (uuid, type: ModalType) => {
  //   const notAblePublishText = (
  //     <div>
  //       <div className={css.errorPublish}>
  //         {type == ModalType.ArchiveDiscount
  //           ? 'Archiving will deactivate this discount. You may find the archived discount in the archive section and restore it at any time.'
  //           : 'Please fix all errors before publish.'}
  //       </div>{' '}
  //       <ModalFooter
  //         onCancel={() => setShowModal(false)}
  //         okText={
  //           type == ModalType.ArchiveDiscount ? 'Archive' : 'Go to editing'
  //         }
  //         onOk={() =>
  //           type == ModalType.ArchiveDiscount
  //             ? handleChangeStatus(uuid, StatusChange.Archive)
  //             : handleGotoEdit(uuid)
  //         }
  //       />
  //     </div>
  //   );
  //   setModalContent(notAblePublishText);
  //   setModalTitle(
  //     type == ModalType.ArchiveDiscount
  //       ? 'Archive Discount'
  //       : 'Unable to Publish',
  //   );
  //   setShowModal(true);
  // };

  //清除table状态
  const clearTableState = () => {
    setSelectedRowKeys([]);
    setMappedSelectedKeys([]);
    setSelectedAll(false);
  };

  //关闭弹窗
  // const onModalCancel = () => {
  //   setShowModal(false);
  // };

  //tab改变事件
  const tabChange = (activeKey) => {
    clearTableState();
    clearSearchState();
    setCurrent(0);
    // dispatch(activeChange(activeKey));
    setTabActive(activeKey);
  };
  //分页配置
  const paginationProps = {
    defaultPageSize: pageSize,
    showQuickJumper: true,
  };

  const getProduct = (cb) => {
    if (!loading) {
      setLoading(true);
    }
    // const data = search;
    const status = tabsActive
      ? { statusList: [tabsActive] }
      : {
          statusList: [
            EnumStatus.Active,
            EnumStatus.Draft,
            EnumStatus.Issued,
            //  EnumStatus.Scheduled,
            EnumStatus.Expired,
            //   EnumStatus.Archived,
          ],
        };
    const _data = { ...(search || {}), ...status, sortBy, ...constants };
    getVouchersListPage(
      {
        ..._data,
        // salesChannelUuid: salesChannelUuid,
        // firstRow: current * pageSize,
        // sizePerPage: pageSize,
      },
      current * pageSize,
      pageSize,
    ).then((res) => {
      console.log(res);
      const { vouchers } = res;
      const { results } = vouchers || {};
      // const { salesChannelName } = res;
      //  const { totalCount, results } = res.result as any;
      setTotal(vouchers?.totalCount);
      // setTimezoneInGmt(zoneIdToGmt);
      //  setSalesChannelName(salesChannelName);
      setFlashSales(results);
      setLoading(false);
    });
  };

  React.useEffect(() => {
    if (canViewList) {
      getProduct(() => void 0);
    }
  }, []);

  useAfterDidMountEffect(() => {
    if (canViewList) {
      getProduct(() => void 0);
    }
  }, [tabsActive, current]);

  useAfterDidMountEffect(() => {
    if (canViewList) {
      if (!current) {
        getProduct(() => void 0);
      } else {
        setCurrent(0);
      }
    }
  }, [pageSize, search, sortBy]);

  const pageLayoutProps = {
    title: getI18n('general.sider.voucher'),
    // addButtonOverlay,
    // addText: 'Add Subscription Buy',
    // addFun,
    tabChange,
    activeKey: tabsActive,
    tabsConfig,
  };

  const handleGotoEdit = (uuid) => {
    history.push(
      `/salesChannel/discounts/voucher/editor/${salesChannelUuid}/${uuid}`,
    );
  };

  // const handleChangeStatus = (uuids, type, canPublish?) => {
  //   if (canPublish === false && type == StatusChange.Publish) {
  //     statusChangeModal(uuids[0], ModalType.UnableToPublish);
  //   } else {
  //     const changeStatusRequestList = {
  //       [StatusChange.Publish]: publishSubscription,
  //       [StatusChange.ToDraft]: toDraftSubscription,
  //       [StatusChange.Archive]: archiveSubscription,
  //       [StatusChange.Duplicate]: duplicateSubscription,
  //     };
  //     changeStatusRequestList[type](uuids).then(() => {
  //       setShowModal(false);
  //       getProduct(() => void 0);
  //     });
  //   }
  // };

  return canViewList ? (
    <React.Fragment>
      <Breadcrumb
        className={css.breadcrumb}
        breadcrumbData={breadcrumbData(salesChannelUuid, salesChannelName, {
          getI18n,
        })}></Breadcrumb>
      <ListPageLayout {...pageLayoutProps} tabChange={tabChange}>
        <GlobalTable
          id='ProductListTable'
          //onTableChange={setProducts}
          hideBulkEditor
          queryProps={queryProps}
          dataSource={flashSales}
          columns={columns(
            handleGotoEdit,
            tabsActive,
            storeTimezoneUTC,
            !canViewDetail,
            { getI18n },
          )}
          selectedAll={selectedAll}
          setSelectedAll={setSelectedAll}
          // buttonMenu={buttonMenu()}
          rowKey='uuid'
          pagination={paginationProps}
          current={current}
          setCurrent={setCurrent}
          pageSize={pageSize}
          setPageSize={setPageSize}
          total={total}
          rowSelection={rowSelection}
          selectedRowKeys={selectedRowKeys}
          hidePagination={total == 0}
          loading={loading}
          onChange={(_, s, sort) => {
            const asc = sort.order == 'ascend' ? true : false;
            // const sortingField = sort.field.replace(/^\S/, (s) =>
            //   s.toUpperCase(),
            // );
            const { field } = sort;
            // console.log('sort', sort);
            setSortBy({ field, ascent: asc });
          }}
        />
      </ListPageLayout>
      {/* <Modal
        width={600}
        visible={showModal}
        title={modalTitle}
        onCancel={onModalCancel}
        cancelText='Cancel'>
        {modalContent}
      </Modal> */}
    </React.Fragment>
  ) : (
    <NoPermission />
  );
};

export default SalesChannelModeAccessControlHOC(memo(SubscriptionBuyList));
